import { useRef } from "react";
import styled from "styled-components/macro";
import { CSSTransition } from "react-transition-group";

import { CardGrid } from "./Card";
import CardSkeleton from "./CardSkeleton";

const DEFAULT_NUM_CARDS = 12;

const CardGridSkeleton = ({
  isIn,
  numCards = DEFAULT_NUM_CARDS,
  targetDevice,
  theme = "light",
}) => {
  const nodeRef = useRef();

  return (
    <GridSkeleton>
      <CSSTransition
        classNames="skeleton"
        in={isIn}
        nodeRef={nodeRef}
        timeout={1000}
        unmountOnExit
      >
        <CardGrid ref={nodeRef}>
          {Array(numCards)
            .fill()
            .map((item, index) => (
              <CardSkeleton
                key={index}
                targetDevice={targetDevice}
                theme={theme}
              />
            ))}
        </CardGrid>
      </CSSTransition>
    </GridSkeleton>
  );
};

const GridSkeleton = styled.div`
  .skeleton-enter {
    opacity: 0;
  }
  .skeleton-enter-active {
    opacity: 1;
    transition: opacity 1s;
  }
  .skeleton-exit {
    opacity: 1;
  }
  .skeleton-exit-active {
    opacity: 0;
    transition: opacity 1s;
  }
`;

export default CardGridSkeleton;
